(function () {
  'use strict';

  try {
    var STORAGE_KEY = 'line_popup_closed_until';

    var popup = document.getElementById('line-popup');
    if (!popup) return;

    var delay = parseInt(popup.dataset.delay, 10) || 10;
    var expireDays = parseInt(popup.dataset.expire, 10) || 7;
    var showPc = popup.dataset.showPc !== 'false';
    var showSp = popup.dataset.showSp !== 'false';
    var enableGa4 = popup.dataset.ga4 !== 'false';
    var lineUrl = popup.dataset.lineUrl || '';

    // デバイス判定（749px以下をスマホとする）
    var isSp = window.matchMedia('(max-width: 749px)').matches;

    // デバイス表示設定チェック
    if (isSp && !showSp) return;
    if (!isSp && !showPc) return;

    // 再表示抑制チェック
    try {
      var closedUntil = localStorage.getItem(STORAGE_KEY);
      if (closedUntil && Date.now() < parseInt(closedUntil, 10)) return;
    } catch (e) {
      // localStorage が使えない環境では抑制しない
    }

    // GA4 dataLayer push helper
    function pushEvent(eventName, extra) {
      if (!enableGa4) return;
      try {
        window.dataLayer = window.dataLayer || [];
        var payload = Object.assign({ event: eventName }, extra || {});
        window.dataLayer.push(payload);
      } catch (e) {}
    }

    // ポップアップを表示
    function showPopup() {
      popup.removeAttribute('hidden');
      // 1フレーム後にクラス付与してトランジションを発火
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          popup.classList.add('is-visible');
          pushEvent('line_popup_view', { line_url: lineUrl });
        });
      });
    }

    // ポップアップを閉じる
    function closePopup() {
      popup.classList.remove('is-visible');
      pushEvent('line_popup_close', { line_url: lineUrl });

      // トランジション完了後に非表示
      popup.addEventListener('transitionend', function handler() {
        popup.setAttribute('hidden', '');
        popup.removeEventListener('transitionend', handler);
      });

      // localStorageに閉じた日時を記録
      try {
        var expireMs = expireDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(STORAGE_KEY, String(Date.now() + expireMs));
      } catch (e) {}
    }

    // 閉じるボタン
    var closeBtn = document.getElementById('line-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closePopup();
      });
    }

    // リンククリックのGA4イベント
    var link = document.getElementById('line-popup-link');
    if (link) {
      link.addEventListener('click', function () {
        pushEvent('line_popup_click', { line_url: lineUrl });
      });
    }

    // 遅延表示
    setTimeout(showPopup, delay * 1000);

  } catch (e) {
    // エラーが購入導線に影響しないよう握りつぶす
    if (typeof console !== 'undefined' && console.error) {
      console.error('[line-popup] 初期化エラー:', e);
    }
  }
})();
